import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Header from './cmp/header';
import MySidebar from './cmp/nav';
import Login from './cmp/login';
import Dashboard from './cmp/dashboard';
import AdminProfile from './cmp/profile';
import UserDetails from './cmp/users_detail';
import SendNotification from './cmp/send_notification';
import AdminContact from './cmp/contact';
import Lectures from './cmp/lectures';
import AddLecture from './cmp/add-lecture';
import ViewLecture from './cmp/view-lecture';
import Cases from './cmp/cases';
import AddCase from './cmp/add-case';
import QuizList from './cmp/quiz-list';
import AddEditQuiz from './cmp/add-quiz';
import DrugRefs from './cmp/drug-refs';
import AddDrugRef from './cmp/add-drug-ref';
import FractureQuizList from './cmp/fracture-quiz-list';
import AddEditFractureQuiz from './cmp/add-fracture-quiz';
import AdminIllustrationsList from './cmp/illustrations-list';
import AddIllustration from './cmp/add-illustration';

// Container for the login page
const LoginContainer = () => <Login />;

// Container for the main admin pages
const HomeContainer = () => (
  <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Header />
      <div style={{ display: 'flex', width: '100%' }}>
        <MySidebar />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Lectures />} />
            <Route path="/profile" element={<AdminProfile />} />
            <Route path="/user-details" element={<UserDetails />} />
            <Route path="/send-notification" element={<SendNotification />} />
            <Route path="/contact" element={<AdminContact />} />
            <Route path="/lectures" element={<Lectures />} />
            <Route path="/add-lecture" element={<AddLecture />} />
            <Route path="/view-lecture" element={<ViewLecture />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/add-case" element={<AddCase />} />
            <Route path="/quiz-list" element={<QuizList />} />
            <Route path="/add-quiz" element={<AddEditQuiz />} />
            <Route path="/fracture-quiz-list" element={<FractureQuizList />} />
            <Route path="/add-fracture-quiz" element={<AddEditFractureQuiz />} />
            <Route path="/illustrations" element={<AdminIllustrationsList />} />
            <Route path="/add-illustration" element={<AddIllustration />} />
            <Route path="/drug-refs" element={<DrugRefs />} />
            <Route path="/add-drug-ref" element={<AddDrugRef />} />
          </Routes>
        </div>
      </div>
    </div>
  </div>
);

export default function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<LoginContainer />} />
      <Route path="/*" element={<HomeContainer />} />
    </Routes>
  );
}
